import { getDbSafe } from "../firebase";
import { doc, collection } from "firebase/firestore";

export function employerWalletRef(uid: string) {
  return doc(getDbSafe(), "employerWallets", uid);
}
export function emtWalletRef(uid: string) {
  return doc(getDbSafe(), "emtWallets", uid);
}
export function unlockRef(unlockId: string) {
  return doc(getDbSafe(), "profileUnlocks", unlockId);
}
export function entitlementRef(employerUid: string, emtUid: string) {
  return doc(getDbSafe(), "unlockedProfiles", employerUid, "emts", emtUid);
}
export function verificationLogsCol(emtUid: string) {
  return collection(getDbSafe(), "verificationLogs", emtUid, "logs");
}
export function employerProfilesSettingsRef(uid: string) {
  return doc(getDbSafe(), "employerProfilesSettings", uid);
}
